import { cn } from "@/lib/utils";

export function Panel({ title, action, className, children, testId }) {
  return (
    <div data-testid={testId} className={cn("bg-white rounded-[20px] shadow-[0_1px_2px_rgba(0,0,0,0.03),0_10px_30px_rgba(17,24,39,0.05)]", className)}>
      {(title || action) && (
        <div className="flex flex-wrap items-center justify-between gap-2 px-3 sm:px-5 py-2.5 sm:py-3 border-b border-[#F2F2F7]">
          {title && <h3 className="text-sm font-semibold tracking-tight text-[#1D1D1F] min-w-0">{title}</h3>}
          {action}
        </div>
      )}
      <div className="p-3 sm:p-5">{children}</div>
    </div>
  );
}

export function Stat({ label, value, sub, tone = "slate" }) {
  const tones = {
    slate: "text-slate-900", amber: "text-amber-700", emerald: "text-emerald-700",
    rose: "text-rose-700", indigo: "text-indigo-700", blue: "text-blue-700", orange: "text-orange-700",
  };
  return (
    <div>
      <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-500 leading-tight">{label}</div>
      <div className={cn("mono text-base sm:text-xl font-bold mt-0.5 break-words", tones[tone])}>{value}</div>
      {sub && <div className="text-xs text-slate-500 mt-0.5">{sub}</div>}
    </div>
  );
}

const STATUS_STYLES = {
  CONFIRMED: "bg-emerald-100 text-emerald-800 border-emerald-300",
  PENDING: "bg-amber-100 text-amber-800 border-amber-300",
  CANCELLED: "bg-slate-100 text-slate-600 border-slate-300",
  CORRECTED: "bg-rose-100 text-rose-800 border-rose-300",
};
const TYPE_STYLES = {
  AMBIL: "bg-blue-100 text-blue-800 border-blue-300",
  SETOR: "bg-emerald-100 text-emerald-800 border-emerald-300",
  BON: "bg-indigo-100 text-indigo-800 border-indigo-300",
  BAYAR: "bg-slate-100 text-slate-700 border-slate-300",
  KASBON: "bg-orange-100 text-orange-800 border-orange-300",
  PINJAMAN: "bg-fuchsia-100 text-fuchsia-800 border-fuchsia-300",
  KOREKSI: "bg-rose-100 text-rose-800 border-rose-300",
  SALDO_AWAL: "bg-amber-100 text-amber-800 border-amber-300",
  RIJEK: "bg-orange-100 text-orange-800 border-orange-300",
};

export function Pill({ kind = "status", value }) {
  const map = kind === "type" ? TYPE_STYLES : STATUS_STYLES;
  return (
    <span className={cn("inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border", map[value] || "bg-slate-100 text-slate-700 border-slate-300")}>
      {value}
    </span>
  );
}

export function PageTitle({ title, desc, right }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-4 sm:mb-6 pt-1">
      <div className="min-w-0">
        <div className="text-[11px] font-semibold tracking-widest text-[#0071E3] mb-1 hidden">CV. Meranggi Jaya</div>
        <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-[#1D1D1F]">{title}</h1>
        {desc && <p className="text-xs sm:text-sm text-[#6E6E73] mt-1 no-up max-w-3xl hidden sm:block">{desc}</p>}
      </div>
      {right && <div className="flex flex-wrap gap-2 items-center">{right}</div>}
    </div>
  );
}
